import { SET_UDAS_SOCKET } from "redux/constants/portal";

export const setUdasSocket = (payload) => ({
  type: SET_UDAS_SOCKET,
  payload,
});
